<h2 mat-dialog-title>Detalles de la Novedad</h2>
<mat-dialog-content>
  <div class="container py-3">
    <!-- Información principal -->
    <div class="row mb-4">
      <div class="col-12">
        <mat-card>
          <mat-card-content>
            <div class="row">
              <div class="col-md-6">
                <p><strong>Periodo:</strong> {{data.novedad.periodo}}</p>
                <p><strong>Tipo de Novedad:</strong> {{data.tipoNovedadDescripcion}}</p>
              </div>
              <div class="col-md-6">
                <p><strong>Vendedor:</strong> {{data.vendedorNombre}}</p>
                <p><strong>Días:</strong> {{data.novedad.dias}}</p>
              </div>
            </div>
            <!-- Observaciones -->
            <div class="row mt-3">
              <div class="col-12">
                <p><strong>Observaciones:</strong></p>
                <p class="text-wrap">{{data.novedad.observaciones || 'Sin observaciones'}}</p>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <!-- Información de auditoría -->
    <div class="row">
      <div class="col-md-6">
        <mat-card>
          <mat-card-header>
            <mat-card-title class="fs-6">Información de Creación</mat-card-title>
          </mat-card-header>
          <mat-card-content class="pt-3">
            <p><strong>Usuario:</strong> {{data.novedad.usuario_creacion}}</p>
            <p><strong>Fecha:</strong> {{data.novedad.fecha_creacion ? (data.novedad.fecha_creacion | date:'dd/MM/yyyy') : 'No disponible'}}</p>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-md-6" *ngIf="data.novedad.usuario_modificacion && data.novedad.fecha_modificacion">
        <mat-card>
          <mat-card-header>
            <mat-card-title class="fs-6">Última Modificación</mat-card-title>
          </mat-card-header>
          <mat-card-content class="pt-3">
            <p><strong>Usuario:</strong> {{data.novedad.usuario_modificacion}}</p>
            <p><strong>Fecha:</strong> {{data.novedad.fecha_modificacion | date:'dd/MM/yyyy'}}</p>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>
